import { useCurrentUserQuery } from '@features/auth/queries/auth.queries';

export function useBulkAccess() {
  const { data: currentUser } = useCurrentUserQuery();
  const roleId = currentUser?.roleId || currentUser?.role?.id || 0;
  const isOrgAdmin = roleId === 4;
  const bulkEnabled = isOrgAdmin;
  return { bulkEnabled };
}
